export const Device = {
  Tablet: '768px',
  MobileS: '320px',
  MobileM: '375px',
  MobileL: '425px',
};

export const BCA_TERMS =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/pdf/vodalend-merchant-agreement-2.pdf';

export const downloadToPUrl =
  'https://play.google.com/store/apps/details?id=za.co.synthesis.halo.mpos.vodacom&hl=en_US&utm_source=Buy%20POS%20Website&utm_medium=Web%20Journey&utm_campaign=Lets%20get%20started';

export const publicSiteUrl =
  'https://www.vodacombusiness.co.za/business/solutions/financial-services/e-commerce';

export const vfsHomeUrl = 'https://www.vodacombusiness.co.za/business/solutions/financial-services';

export const bcaContractTermsAndConditionsUrl =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/pdf/vodalend-merchant-agreement-03.pdf';

export const vodalendDigitalTerms =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/terms-and-conditions/vodacom-merchant-agreement.pdf ';

export const merchantAgreementTerms =
  'https://www.vodacombusiness.co.za/resource-file/4cjshjkk9jknhldgk0s9bn/vodacom-merchant-agreement.pdf';

export const contacts = {
  number: '011 066 0847',
  numberUrl: 'tel:0110660847',
  email: 'sinawe@vodacom.co.za',
  emailUrl: 'mailto:sinawe@vodacom.co.za',
};

export const provinces = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'Northern Cape',
  'North West',
  'Western Cape',
];

export const RETRY_ATTEMPT = 3;

export const xLinkContacts = {
  number: '080 000 0654',
  numberUrl: 'tel:0800000654',
  email: 'VPS@xlink.co.za',
  emailUrl: 'mailto:VPS@xlink.co.za',
  whatsapp: '072 605 9421',
  whatsappUrl: 'https://wa.me/27726059421',
};

export const privacyNoticeUrl =
  'https://www.vodacom.co.za/vodacom/terms/privacy-policy/payment-services';

// Salesforce only allows the date picker to select a date from the year 1700 and up.
export const MIN_DATE_ALLOWED = new Date('01/01/1700');

export const DEBUG_CONFIG_KEY = 'debugConfig';
export const DEV_TOOLS_KEY = 'devTools';

export const TITLES = ['Mr', 'Mrs', 'Miss', 'Dr', 'Prof'];
export const CREDIT_VETTING_TITLES = ['Mr', 'Mrs', 'Miss', 'Dr'];
export const tapOnPhoneSessionKey = 'tap_on_phone_journey';

export type BCATermsItem = {
  title: string;
  children?: BCATermsItem[];
  subtitle?: string;
};

export const bcaContractTerms: BCATermsItem[] = [
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>introduction</p>',
    children: [
      { title: 'As at the Acceptance Date the Merchant conducts the Business.' },
      {
        title:
          'The Facilitator, being Vodacom Payment Services (Pty) Ltd (“Vodalend”) introduced and/or originated the Business Opportunity for the Merchant and Lula Lend with the purpose and intention of Lula Lend and the Merchant concluding this Agreement.',
      },
      { title: 'Lula Lend has identified the Future Revenue as an asset of the Business.' },
      {
        title: 'The Merchant utilises a Payment Device in terms of an agreement with the Acquirer.',
      },
      {
        title:
          'The Merchant wishes to obtain an advance payment for the discounted sale of the Future Revenue and wishes to sell such Future Revenue to Lula Lend at an agreed discount value.',
      },
      {
        title:
          'Lula Lend has agreed to purchase the Future Revenue from the Merchant. Lula Lend has assessed the historic and current sales of the Merchant to determine the maximum Advance amount applicable in respect of the purchase of the Merchant’s Future Revenue using its Projections to estimate that the Merchant is able to generate sufficient sales to enable it to repay the Advance in terms hereof within the Estimated Term. Lula Lend will monitor the Merchant’s sales according to these Projections throughout the duration of this Agreement to ensure the Merchant is able to repay the Advance in full within the Estimated Term.',
      },
      { title: 'This is the agreement between the parties.' },
    ],
  },

  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>definitions</p>',
    children: [
      {
        title:
          'In this Agreement, unless inconsistent with or otherwise indicated by the context -',
        children: [
          {
            title:
              '“<span class="font-bold">Acceptance Date</span>” means the date upon which the Merchant accepts the terms and conditions of this Agreement by clicking the acceptance tab on the offer page of the mobile application or computer software programme of the Facilitator, alternatively by signing this Agreement electronically;',
          },
          {
            title:
              '“<span class="font-bold">Acquirer/s</span>” means the banks and/or independent service operators which own the electronic processing equipment, and which facilitate Payments to the Nominated Bank Account of the Merchant;',
          },
          {
            title:
              '“<span class="font-bold">Acquiring Contracts</span>” means the agreements between the Merchant and/or Facilitator and/or Acquirer for the provision of the acquiring services by the Acquirer to the Merchant and/or Facilitator;',
          },
          {
            title:
              '“<span class="font-bold">Advance</span>” means the purchase price payable by Lula Lend to the Merchant for the Future Revenue;',
          },
          {
            title:
              '“<span class="font-bold">Advance Date</span>” means the date upon which Lula Lend makes payment of the Advance into the Payment Account;',
          },
          {
            title:
              '“<span class="font-bold">the/this Agreement</span>” means this agreement, and all and any annexures and addendum thereto, the Application and the Offer Page and the Merchants’ profile on the App and includes any annexures, addenda, appendices and schedules referred to in any of the documents or applications referred to in this Agreement;',
          },
          {
            title:
              '“<span class="font-bold">Agreed Percentage</span>” means the percentage, as reflected in the Offer Page and on the cover page of this Agreement, of the Future Revenue amounts collected and received by the Merchant from its customers by way of credit card, debit card, electronic funds transfer or any other form of payment accepted by the Merchant through the Payment Device and which is to be paid to Lula Lend in terms of clause 6 below;',
          },
          {
            title:
              '“<span class="font-bold">App</span>” means the mobile or online computer programme of the Facilitator on which the Merchant has a profile and whereby the Merchant completes an Application form on the program, and based on the financial and other information provided by the Merchant, Lulalend offers to purchase the Merchant’s future receivables at a certain amount subject to the terms and conditions contained herein;',
          },
          {
            title:
              '“<span class="font-bold">Application</span>” means the application submitted by the Merchant on the App to Lulalend for the sale of the Merchant’s Future Revenue, which will include, but not limited to, the financial information of the Merchant;',
          },
          {
            title:
              '"<span class="font-bold">Business</span>" means the business conducted by the Merchant as confirmed by the Merchant on the App, the Offer Page and specified on the cover page hereof;',
          },
          {
            title:
              '“<span class="font-bold">Business Opportunity</span>” means potential deals or opportunities pursuant to which Lula Lend may acquire Future Revenue from a Merchant at an agreed discount value in consideration for which the Merchant may obtain an advance payment for the discounted sale of such Future Revenue;',
          },
          {
            title:
              '“<span class="font-bold">Business Day</span>” means any day on which the Merchant trades and conducts its Business, receiving payments from its customers;',
          },
          {
            title:
              '“<span class="font-bold">Business Premises</span>” means the premises from which the Business is conducted as identified in the Offer Page and on the cover page hereof and on the Merchants’ profile on the App;',
          },
          {
            title:
              '“<span class="font-bold">Disposal</span>” means any sale, transfer, out and out cession, assignment, lease, alienation, donation, renunciation, surrender, waiver, relinquishment, exchange or other disposal of any nature whatsoever, and “Dispose” has a corresponding meaning;',
          },
          {
            title:
              '“<span class="font-bold">Encumbrance</span>” means any right or interest of any person (including any right to acquire, option or right of pre-emption) or any mortgage, charge, pledge, security cession, lien, hypothecation, notarial bond or any other form of security, interest or encumbrance whatsoever, howsoever created or arising to or in respect of any assets and/or shares and/or interest in the Merchant and “Encumber” shall have a corresponding meaning;',
          },
          {
            title:
              '“<span class="font-bold">Facilitator</span>” means Vodacom Payment Services (Pty) Ltd, with Registration number 2007/010688/07, a private company duly incorporated in terms of the company laws of the RSA;',
          },
          {
            title:
              '“<span class="font-bold">Future Revenue</span>” means all the Merchant’s claims arising against its customers for payment to the Merchant during the conduct of its Business, limited to the total rand value reflected as the Future Revenue Total Rand Value in the Offer Page and / or on the cover page, plus all additional amounts which may become due and payable by the Merchant under this Agreement, and which forms the subject of this Agreement;',
          },
          {
            title:
              '“<span class="font-bold">Future Revenue Total Rand Value</span>” means the total amount payable by the Merchant to Lula Lend in respect of the advance payment for the discounted sale as provided for in this Agreement;',
          },
          {
            title:
              '“<span class="font-bold">Law</span>” means common law, legislation, regulations and any subsidiary legislation prevailing from time to time in the RSA;',
          },
          {
            title:
              '“<span class="font-bold">Loss</span>” means any loss, liability, claim, costs, charges and damages of any nature whatsoever without limitation, including, legal costs and expense, compensation payable under contracts, loss of normal operating profits, loss of opportunity, loss of goodwill, loss of revenue from related contracts and pure economic loss, tracing and collection charges, costs of investigation, interest and penalties;',
          },
          {
            title:
              '“<span class="font-bold">Lula Lend</span>” means Lula Lend (Proprietary) Limited, (registration number 2014/156767/07), a company duly registered and incorporated in the RSA and with registered address situated at 3rd Floor, Pier Place, Heerengracht Street, Cape Town;',
          },
          {
            title:
              '“<span class="font-bold">the Merchant</span>” means the party which is identified in the Offer Page and on the cover page hereof from whom the Future Revenue is purchased by Lula Lend in terms of this Agreement;',
          },
          {
            title:
              '"<span class="font-bold">Nominated Bank Account</span>” means the bank account/s nominated by the Merchant which shall take receipt of the Payments;',
          },
          {
            title:
              '“<span class="font-bold">Offer Page</span>” means the page on the Facilitator’s App where Lula Lend offers the Merchant an advance payment for the discounted sale of the Future Revenue;',
          },
          {
            title:
              '“<span class="font-bold">the Parties</span>” means the Merchant and Lula Lend and “Party” means any one of them;',
          },
          {
            title:
              '“<span class="font-bold">Payment/s</span>” means payments made by the Merchant’s customers to the Merchant to pay for goods and/or services purchased, including but not limited to payment by way of credit and debit cards, electronic funds transfer, mobile payments, and any other form of payment other than a payment by cash or cheque;',
          },
          {
            title:
              '“<span class="font-bold">Payment Account</span>” means the bank account nominated by the Merchant for the purposes of Lula Lend making payment of the Advance;',
          },
          {
            title:
              '“<span class="font-bold">Payment Device</span>” means the payment device owned by the Acquirer and through which Payments are facilitated between the Merchant and its customers into the Merchant’s Nominated Bank Account;',
          },
          {
            title:
              '"<span class="font-bold">Projections</span>" means Lula Lend’s estimated Advance repayments to be made by the Merchant within the Estimated Term calculated by taking into account the historical transactional data processed through the income collected via the Facilitator;',
          },
          {
            title:
              '“<span class="font-bold">Rands</span>” means RSA Rands, the legal currency of the RSA;',
          },
          { title: '“<span class="font-bold">RSA</span>” means the Republic of South Africa;' },
        ],
      },
      {
        title:
          'any reference in this Agreement to an enactment is to that enactment as at the Acceptance Date and as amended or re-enacted from time to time;',
      },
      {
        title:
          'if any provision in a definition is a substantive provision conferring rights and imposing obligations on any Party, effect shall be given to it as if it were a substantive provision of this Agreement;',
      },
      {
        title:
          'when any number of days is prescribed in this Agreement, same shall be reckoned inclusively of the first and exclusively of the last unless the first day falls on a day which is not a Business Day in which case the first day shall be the next succeeding Business Day;',
      },
      {
        title:
          'the rule of construction that in the event of ambiguity, the contract shall be interpreted against the party responsible for the drafting thereof, shall not apply in the interpretation of this Agreement;',
      },
      {
        title:
          'the expiration or termination of this Agreement will not affect any provisions which provide that they will operate after suc h expiration or termination or which of necessity must continue to have effect after such expiration or termination;',
      },
      {
        title: 'unless inconsistent with the context, an expression which denotes:',
        children: [
          { title: 'any one gender includes the other gender;' },
          {
            title: 'a natural person includes a juristic and/or artificial person and vice versa;',
          },
        ],
      },
      {
        title:
          'the use of the word “including” followed by a specific example/s shall not be construed as limiting the meaning of the general wording preceding it and the eiusdem generis rule shall not be applied in the interpretation of such general wording or such specific example/s;',
      },
      {
        title:
          'where figures are referred to in numerals and in words, if there is any conflict between the two, the words shall prevail;',
      },
      {
        title:
          'reference to any Party shall be deemed to include Party’s estate, heirs, executors, administrators, trustees or assigns as the case may be.',
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>sale and cession</p>',
    subtitle:
      'The Merchant hereby sells, cedes and transfers all its rights, title and interest in and to the Future Revenue to Lula Lend and Lula Lend hereby accepts such sale, cession and transfer with effect from the Advance Date.',
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>payment of advance</p>',
    children: [
      {
        title:
          'In consideration for the sale of the Future Revenue by the Merchant to Lula Lend, Lula Lend shall pay the Advance to the Merchant on the Advance Date by way of electronic transfer into the Payment Account. The Merchant hereby undertakes and agrees that it shall have no claim against Lula Lend for any Loss arising as a result of payment by Lula Lend of the Advance into the Payment Account and the Merchant hereby indemnifies Lula Lend accordingly.',
      },
      {
        title:
          'The Advance paid by Lulalend is for the purchase of the Future Revenue and is not a loan from Lulalend to the Merchant.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>passing and ownership of future revenue</p>',
    children: [
      {
        title:
          'Once the Advance has been paid to the Merchant by Lula Lend into the Payment Account –',
        children: [
          {
            title:
              'Lula Lend shall own the right, title and interest in and to the Future Revenue without the need for any other act of transfer;',
          },
          {
            title:
              'the Merchant shall have no right to repurchase the Future Revenue or any part thereof, save as expressly provided in terms of this Agreement.',
          },
        ],
      },
      {
        title:
          'It is the intention of the Parties that each purchase and sale of Future Revenue pursuant to this Agreement shall be a valid sale which shall have the effect on the Merchant, as legal and beneficial owner selling and ceding absolutely with full title guarantee, the Future Revenue to Lula Lend. Save as otherwise expressly provided herein, such sale and cession are absolute and irrevocable but does not constitute and is not intended to result in an assumption by Lula Lend of any of the Merchant’s obligations in connection with the Future Revenue or any other of the Merchant’s obligations whatsoever.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>payment of future revenue and merchant’s obligation to collect future revenue</p>',
    children: [
      {
        title:
          'The Merchant undertakes at its own expense and without charge to Lula Lend, as agent for and on behalf of Lula Lend to collect the Future Revenue. In this regard, the Merchant makes use of the Payment Device and undertakes to continue to do so for the duration of this Agreement.',
      },
      {
        title:
          "While acting as Lula Lend's agent for the collection of Future Revenue the Merchant shall –",
        children: [
          {
            title:
              'not give any extension of time to make payment, make any allowance, waiver any right or obligation, change any terms of or cancel the transaction and/or grant any other indulgence to its customers of any nature without the prior written consent of Lula Lend;',
          },
          {
            title:
              'furnish Lula Lend, as and when required by Lula Lend, with any report or information or document in its possession as required by Lula Lend in respect of any Future Revenue;',
          },
          {
            title:
              'render to Lula Lend all reasonable assistance required by Lula Lend in connection with the collection of any Future Revenue.',
          },
        ],
      },
      {
        title:
          'The Merchant hereby agrees that on every Business Day, upon receipt of any Future Revenue collected by the Merchant as agent of Lula Lend, the Merchant shall pay to Lula Lend the Agreed Percentage of such Future Revenue (“<span class="font-bold">Approximate Daily Repayment Amount</span>”), until such time as the entire Future Revenue Total Rand Value as set out in the Offer Page and on the cover page hereof has been paid in full to Lula Lend.',
      },
      {
        title:
          'It is agreed between the Parties that the Facilitator shall remit the Approximate Daily Repayment Amount to Lula Lend on behalf of the Merchant, into a bank account nominated in writing by Lula Lend from time to time for this purpose, in accordance with the following process:',
        children: [
          {
            title:
              'at the end of each Business Day, the Facilitator shall deduct the Approximate Daily Repayment Amount from all Future Revenue collected by the Merchant through the Payment Device for such Business Day from the Merchant’s customer’s bank account;',
          },
          {
            title:
              'the Approximate Daily Repayment Amount shall be paid by the Facilitator to Lula Lend;',
          },
          {
            title:
              'the remaining amount of revenue collected by the Merchant for such Business Day shall be credited to the Merchant’s Nominated Bank Account, less the percentage fee payable to the Facilitator as agreed between the Facilitator and the Merchant in terms of the Agreement between the Facilitator and the Merchant in respect of the Payment Device.',
          },
        ],
      },
      {
        title:
          "The Merchant's mandate in terms hereof to collect Future Revenue on behalf of Lula Lend shall endure until the full amount due to Lula Lend in terms of this Agreement is paid by the Merchant, being the Future Revenue Total Rand Value, alternatively until such time as the Merchant is instructed otherwise by Lula Lend in terms of clause 10.",
      },
      {
        title:
          '<span class="font-bold">Should the Merchant elect at any stage while this Agreement remains effective, to terminate its agreement with the Facilitator in respect of the Payment Device, resulting in the Payment Device being returned to the Facilitator, this Agreement shall be terminated and the full outstanding balance of the Future Revenue Total Rand Value shall be immediately due and payable by the Merchant to Lula Lend. In this regard, the Merchant undertakes to notify Lula Lend in writing of its intention to terminate its agreement with the Facilitator at least 20 business days prior to such termination and to make payment of the Future Revenue Total Rand Value outstanding prior to returning the Payment Device to the Facilitator. In the event of the Merchant failing to notify Lula Lend of the termination of its agreement with the Facilitator as required in terms hereof, the provisions of clause 10.6 shall apply.</span>',
      },
      {
        title:
          'The Merchant hereby agrees that its obligations under this Agreement shall not be affected by the invalidity, unenforceability, existence, performance or non-performance by the Merchant or any of its customers (including partial payment or late payment) of the relevant underlying transaction (in respect of which the Future Revenue or part thereof, was concluded) any liability for which shall be between the Merchant and its customer.',
      },
      {
        title:
          'In the event that any of the Future Revenue are for any reason reversed, Lulalend shall not repay the Merchant the Approximate Daily Repayment Amount (or any portion thereof).',
      },
      {
        title:
          '<span class="font-bold">Lula Lend shall monitor the Merchant’s sales throughout the duration of this Agreement and ensure the Merchant is tracking according to its Projections. Some repayment flexibility is allowed, however, in the event that the Merchant is tracking behind Lula Lend’s Projections by more than 20% at any point during the Estimated Term, Lula Lend shall contact the Merchant in order to determine the reasons for the Merchant tracking behind. In such instances, and in order to assist the Merchant from falling further behind, Lula Lend shall request the Merchant to make top-up EFT payments or to agree to increase the hold back rate applicable to the Advance. The Merchant shall not unreasonably withhold its consent to such top-up EFT payments or increase in the hold back rate applicable.</span>',
      },
      {
        title:
          '<span class="font-bold">In the event of the Merchant failing to use the Payment Device for a consecutive period exceeding 14 days and has failed to contact Lula Lend to make alternative payment arrangements, the Merchant hereby authorises a debit order to be activated from the Payment Account in favour of Lula Lend for the payment of the Future Revenue Total Rand Value, to be paid weekly in equal instalments over the remaining initial Estimated Term, directly from the Merchant’s nominated Payment Account or any other account as agreed by the Merchant, on condition that the sum of the payment instructions will not exceed the Future Revenue Total Rand Value outstanding as agreed and defined in this Agreement. By accepting the terms of this Agreement, the representative of the Merchant executing this Agreement and acting on behalf of the Merchant, hereby authorises Lula Lend to issue and deliver the debit order payment instruction for the collection against the Merchant Payment Account of the outstanding Future Revenue Total Rand Value as provided for in this clause.</span>',
      },
      {
        title:
          '<span class="font-bold">In the event of the Merchant failing to repay the Future Revenue Total Rand Value within the Estimated Term specified by the Merchant in the Offer Page, and provided Lula Lend has contacted the Merchant and demanded payment of the Future Revenue Total Rand Value then outstanding and the Merchant having failed to make payment thereof, Lula Lend shall be entitled to debit the outstanding Future Revenue Total Rand Value in full directly from the Merchant’s nominated Payment Account. In the event of the Merchant having insufficient funds to allow for the debit of the Future Revenue Total Rand Value in full, Lula Lend shall be entitled to debit the nominated Payment Account weekly in equal instalments over a three-month period. In this regard, the Merchant hereby unequivocally authorises Lula Lend to deduct the outstanding Future Revenue Total Rand Value directly from its nominated Payment Account. By accepting the terms of this Agreement, the representative of the Merchant executing this Agreement and acting on behalf of the Merchant, hereby authorises Lula Lend to issue and deliver the debit order payment instruction for the collection against the Merchant Payment Account of the outstanding Future Revenue Total Rand Value after the expiry of the Estimated Term.</span>',
      },
      {
        title:
          'Where the Future Revenue Total Rand Value is being paid by debit order, Lula Lend shall instruct the Facilitator accordingly, to avoid a duplication of the payment of the Future Revenue Total Rand Value.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>merchant\'s warranties</p>',
    subtitle:
      'The Merchant hereby warrants (<span class="font-bold">all of which warranties shall be deemed to be material and upon which Lula Lend has relied in concluding and implementing this Agreement</span>) in favour of Lula Lend that as at the Acceptance Date, the Payment Date and all dates during the period in which any of the Future Revenue remains owing to Lula Lend -',
    children: [
      {
        title:
          'if the Merchant is a limited liability company, close corporation or trust, it is and, in the future, will be duly incorporated or registered and validly existing in accordance with the company laws of the RSA;',
      },
      {
        title:
          'this agreement does not and will not conflict with any Law applicable to the Merchant and/or the Business, its constitutional documents, and/or any agreement binding on the Merchant;',
      },
      {
        title:
          'the Merchant has no obligations to the Acquirers, save for as arising under the Acquiring Contracts;',
      },
      {
        title:
          'the Merchant has and will continue to have all necessary authorisations, consents and licenses to enable it to lawfully enter into, to exercise its rights and to comply with its obligations under the Agreement, and to enable it to operate the Business, own its assets, and to occupy and/or own the Business Premises;',
      },
      {
        title:
          'the financial information provided by the Merchant to Lula Lend is true and correct and accurately represents the Merchant’s financial condition and operations of the Business and are and will in the future be consistent with its financial books, records and accounts. Any financial projections provided by the Merchant to Lula Lend were and, in the future, shall be prepared on the basis of recent and complete historic information and reasonable assumptions in accordance with generally accepted accounting principles;',
      },
      {
        title:
          'no legal process of any nature whatsoever which if, adversely determined, could have a material adverse effect on the Merchant or the Business have been started or threatened;',
      },
      {
        title:
          'the Future Revenue are and will in the future be free from all Encumbrances and is sold by the Merchant to Lula Lend with full title guarantee, and no other person has any right or interest in or to the Future Revenue or any part thereof;',
      },
      {
        title:
          'the Merchant will conduct the Business consistently with past business practice, and not cease to conduct or change the nature of the Business;',
      },
      {
        title:
          'there is and, in the future, will be no factor/circumstance which may impair the ability of the Merchant to deliver the Future Revenue to Lula Lend;',
      },
      {
        title:
          'no Default Event, as defined in clause 10 below, has occurred and/or is continuing to occur and no such event or circumstances will occur as a result of the Merchant entering into or performing its obligations under this Agreement;',
      },
      {
        title:
          'the Merchant will not take any action of any nature whatsoever to discourage, limit or reduce payments being made by its customers through the Payment Device or offer discounts or benefits for payment in cash (including by way of direct Electronic Funds Transfer) and shall in this regard continue to conduct the Business in line with past practice;',
      },
      {
        title:
          'the Merchant will not amend, terminate or take any action that would result in the termination of the Acquiring Contract, or that may cause the current Acquiring Contract to be changed to any other acquirer(s), or that may result in further acquirers being added;',
      },
      {
        title:
          'the Merchant will promptly notify Lula Lend and/or the Facilitator in writing of its intention to Dispose of the Business, which Disposal will require Lula Lend’s and/or the Facilitator’s prior written consent;',
      },
      {
        title:
          'the Merchant will not permit any event to occur which could have an adverse effect on the Business and/or the collection of Future Revenue;',
      },
      {
        title:
          'the Merchant does not and will not conduct the Business under any name other than the Business/Trading Name stated herein;',
      },
      {
        title:
          'the Merchant will not change the place of business from the Business Premises without providing Lula Lend with 1 month’s prior written notice thereof together with the full details of the new premises;',
      },
      {
        title:
          'the Merchant will provide Lula Lend with information regarding its financial condition, the Business and operations which Lula Lend may, in its sole and absolute discretion, require to maintain the accuracy of the information held by Lula Lend;',
      },
      {
        title:
          'the Merchant will promptly notify Lula Lend and/or the Facilitator in writing of the happening of any Default Event;',
      },
      {
        title:
          'the Merchant will not Encumber any of the Future Revenue or its receivables and/or the Business or business assets;',
      },
      {
        title:
          'the Merchant will not Dispose of the Business or its assets or any part thereof to any person;',
      },
      {
        title:
          'the Merchant will maintain insurance in such amounts and against such risks as are consistent with its past business practice and show proof of such insurance to Lula Lend on its request thereof;',
      },
      {
        title:
          'the Merchant will notify Lula Lend and/or the Facilitator in writing as soon as possible of any changes to its financial circumstances or Business.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>undertakings by merchant</p>',
    subtitle: 'By accepting the terms of this Agreement, the Merchant –',
    children: [
      {
        title: 'accepts all of the terms and conditions contained herein and in the Offer Page;',
      },
      {
        title:
          'agrees to be bound by all of the declarations and terms contained in the Agreement;',
      },
      {
        title:
          'declares that all the information that it has given now and previously, and that it may give to Lula Lend in the future is true, accurate and correct in all respects and is not misleading or deceptive in any way;',
      },
      {
        title:
          'acknowledges that Lula Lend is relying on the information that the Merchant has given and will in the future give to Lula Lend;',
      },
      {
        title:
          'acknowledges that the Merchant received and carefully considered a copy of this Agreement prior to accepting to be bound by the terms hereof;',
      },
      {
        title:
          'agrees that Lula Lend will not be liable in respect of any errors or omissions from any particulars given to Lula Lend by the Merchant;',
      },
      {
        title:
          'understands and accepts that all other documentation signed by the Merchant in connection with this Agreement, as if they had been specifically incorporated herein.',
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>termination</p>',
    subtitle:
      'This Agreement shall automatically terminate on the date upon which all the Future Revenue Total Rand Value has been collected and paid by the Merchant to Lula Lend in terms of clause 6 and any additional amounts owing by the Merchant to Lula Lend in terms hereof.',
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>default</p>',
    children: [
      {
        title: 'Each of the events or circumstances in this clause is a Default Event –',
        children: [
          {
            title:
              'the Future Revenue has not been collected and paid to Lula Lend in terms of clause 6;',
          },
          {
            title:
              'a breach by the Merchant of any warranty, term, or condition of this Agreement and failure by the Merchant to rectify the breach within 5 (five) days of written notice from Lula Lend, requiring it to do so;',
          },
          {
            title:
              'any representation, warranty, or statement made by the Merchant in this Agreement, or any other document provided in connection with the Agreement was false, incorrect, or misleading in any material respect when made or becomes false, misleading, or incorrect and the Merchant fails to advise Lula Lend thereof in writing;',
          },
          {
            title:
              'the Merchant is deemed unable to pay its debts as they fall due for the purpose of the Insolvency Act 1986;',
          },
          {
            title:
              'the Merchant becomes the subject of debt review or is placed under administration or under business rescue proceedings;',
          },
          {
            title:
              'any step is taken by any person in relation to the Merchant or its assets for –',
            children: [
              {
                title: 'its winding-up, administration, liquidation or dissolution;',
              },
              {
                title: 'any arrangement with the Merchant’s creditors generally;',
              },
              {
                title:
                  'the appointment of a liquidator, administrator, or trustee- or debt counsellor as the case may be in respect of the Merchant;',
              },
              {
                title: 'the enforcement of any mortgage, charge or other encumbrance;',
              },
              {
                title: 'an attachment, execution, or other creditor process;',
              },
              {
                title: 'the suspension of payments in respect of any debts;',
              },
              {
                title: 'the commencement of business rescue proceedings;',
              },
            ],
          },
          {
            title:
              'the Merchant terminates or purports to terminate this Agreement and/or any payment instruction in favor of Lula Lend;',
          },
          {
            title: 'the Merchant suspends, Disposes of, dissolves, or terminates the Business;',
          },
          {
            title:
              'there is a change in the ownership or control of the Merchant or the Business, and/or in its constitution, and/or in its shareholders (if the Merchant is a limited liability company), its members (if the Merchant is a limited liability partnership), its trustees (if the merchant is a trust) or its partners (if the Merchant is a partnership);',
          },
          {
            title:
              'the Merchant takes any action of any nature whatsoever to limit or reduce payment being made by its customers and/or fails to utilize the Payment Device and/or limits the use thereof in any way whatsoever;',
          },
          {
            title:
              'the Merchant breaches the agreement with the Facilitator and/or the Acquirer which results in the Facilitator and/or the Acquirer terminating or suspending the Acquiring Contracts or any other agreement which results in the termination / suspension of the Merchant’s use of the Payment Device;',
          },
          {
            title:
              'the Merchant sells or Disposes of or permits any Encumbrance over the Future Revenue or any part thereof to any third party; or',
          },
          {
            title:
              'the Merchant generally does anything which may generally prejudice Lula Lend’s rights in term of this Agreement.',
          },
        ],
      },
      {
        title: 'Upon the happening of a Default Event, Lula Lend shall be entitled to –',
        children: [
          {
            title:
              'elect (at its discretion) to cancel, with immediate effect, the sale in respect of the outstanding Future Revenue Total Rand Value which has not yet been collected and paid to Lula Lend as at the date of such Default Event, by providing written notice to the Merchant and such Future Revenue shall forthwith be deemed to be receded to the Merchant (unless otherwise agreed in writing between the parties);',
          },
          {
            title:
              'exercise any right, power, or remedy it has in Law (including, inter alia, a claim for specific performance and/or damages); and',
          },
          {
            title:
              'terminate all or any obligations which it may have to the Merchant under this Agreement.',
          },
        ],
      },
      {
        title:
          'The Merchant will be liable to pay all legal costs on an attorney own client scale that Lula Lend incurs in order to exercise its rights herein, including costs of collection and tracing fees',
      },
      {
        title:
          'Should the sale of any Future Revenue be cancelled and receded to the Merchant in terms of clause 10.2.1-',
        children: [
          {
            title:
              'all existing and future right, title, and interest in and to such Future Revenue shall be deemed with immediate effect to have been receded to the Merchant; and',
          },
          {
            title:
              'the purchase price thereof equal to the Advance paid in accordance with the provisions of clause 4 together with any amount due and payable in terms of this Agreement but for the happening of the Default Event, less any payments made by the Merchant in terms of clause 6 shall forthwith be refunded by the Merchant to Lula Lend.',
          },
        ],
      },
      {
        title:
          'For the avoidance of any doubt, in the event of a Default Event occurring, then Lula Lend shall be entitled to claim from the Merchant, as liquidated damages, the full amount that Lula Lend would have received in the event of the Merchant not having committed the Default Event. This amount will be the outstanding Future Revenue Total Rand Value as at date of the Default Event, plus any amounts owing by the Merchant to Lula Lend pursuant to this Agreement, less any payments made by the Merchant in terms of clause 6.3 up to the date of the Default Event.',
      },
      {
        title:
          '<span class="font-bold">In the event of the Facilitator and/or the Acquirer terminating any agreement with the Merchant which results in the Merchant’s use of the Payment Device being terminated and/or indefinitely suspended, this Agreement shall terminate with immediate effect, and the Future Revenue Total Rand Value outstanding on that date shall be immediately due and payable by the Merchant to Lula Lend in full. In this regard, the Merchant hereby unequivocally authorises Lula Lend to deduct the Future Revenue Total Rand Value outstanding directly from its nominated Payment Account. By accepting the terms of this Agreement, the representative of the Merchant executing this Agreement and acting on behalf of the Merchant, hereby authorizes Lula Lend to issue and deliver a debit order payment instruction for collection against the Merchant Payment Account on condition that the sum of the payment instruction will not exceed the obligations as agreed and defined in this Agreement, being the Future Revenue Total Rand Value then outstanding.</span>',
      },
      {
        title:
          'In the event of the Merchant being sequestrated and/or placed under debt review and/or debt consolidation and/or placed in liquidation and/or business rescue, this Agreement shall terminate immediately on the happening of such event. In this regard the full outstanding balance of the Future Revenue Total Rand Value due and payable to Lula shall be immediately due and payable to Lula without further notice to the Merchant.',
      },
      {
        title:
          'Notwithstanding any termination by Lula Lend, the Merchant hereby indemnifies Lula Lend and holds Lula Lend harmless from and against all and/or any Loss, that it may suffer, incur, or sustain arising out of –',
        children: [
          {
            title: 'the happening of any Default Event, or any termination of this Agreement;',
          },
          {
            title:
              'a breach by the Merchant of its undertakings, warranties, or any other term and condition of this Agreement; and/or',
          },
          {
            title:
              'the protection and enforcement by Lula Lend of its rights and remedies under, and in respect of, this Agreement.',
          },
        ],
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>power of attorney</p>',
    subtitle:
      'As security for the performance by the Merchant of its obligations under this Agreement and to the extent allowed in Law at the time, by accepting the terms of this Agreement, the Merchant appoints Lula Lend and each of Lula Lend’s directors, officers and employees jointly and severally to be the Merchant’s attorney to do any other things Lula Lend requires in order to collect, realise or perfect its ownership of the Future Revenue or to secure the performance by the Merchant of any of its obligations under this Agreement.',
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>access to information</p>',
    children: [
      {
        title: 'the happening of any Default Event, or any termination of this Agreement;',
        children: [
          {
            title:
              'the balance of financial statements and management accounts in respect of the Business;',
          },
          { title: 'bank statements;' },
          {
            title:
              'details of any documentation relating to the Business including agreements entered into with third parties;',
          },
          {
            title:
              'details of any claims of any nature whatsoever in respect of the Business, including but not limited to claims of rates and taxes;',
          },
          {
            title:
              'any other information or documentation which may pertain to the Merchant or the Business.',
          },
        ],
      },
      {
        title:
          'a breach by the Merchant of its undertakings, warranties, or any other term and condition of this Agreement; and/or',
        children: [
          {
            title:
              'assess the Merchant’s, its directors/members and/or authorised signatory’s financial status and/or credit records;',
          },
          {
            title:
              'monitor the operation and performance of the Merchant’s obligations in terms of this Agreement;',
          },
          {
            title:
              'make any necessary enquiries with any third parties in order to confirm the correctness of information provided by the Merchant; and to do so as and when Lula Lend and/or the Facilitator deem necessary for the duration of this Agreement and/or until such time as any amount due and payable by the Merchant in terms of this Agreement has been paid in full to Lula Lend.',
          },
        ],
      },
      {
        title:
          'the protection and enforcement by Lula Lend of its rights and remedies under, and in respect of, this Agreement.',
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>online platform</p>',
    children: [
      {
        title:
          'The Merchant shall create a user account on the Facilitator’s online platform. The Merchant will be able to access this platform while this Agreement and/or any amended agreement is in force. The Merchant will be able to access all information relating to this Agreement, the Future Revenue Total Rand Value outstanding and any additional fees payable in terms hereof.',
      },
      {
        title:
          'It is the Merchant’s responsibility to keep login details, usernames and passwords secure and ensure only those with authority have access to the Online Platform. Lula shall not be held liable in any manner whatsoever for any unauthorized access to the Merchant’s online profile as a result of the Merchant’s failure to secure such details. The Merchant undertakes to notify Lula Lend immediately if a breach of security or confidentiality is suspected.',
      },
      {
        title:
          "All personal information shall be processed in accordance with the Facilitator and Lula Lend's privacy policy, the terms of which are available on their respective website.",
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>popia</p>',
    subtitle:
      'Lula Lend shall conduct its business operations in a manner compliant with the requirements of the Protection of Personal Information Act 4 of 2013 (“POPIA”). In this regard Lula shall process any personal information provided by the Merchant strictly in accordance with the provisions of POPIA. Lula’s Privacy Policy and PAIA manual are available to the Merchant on Lula Lend’s Website.',
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>domicilium and notices</p>',
    children: [
      {
        title:
          'Each notice, demand or other communication relating to this Agreement shall be delivered personally or by recognised courier or electronic communications and shall be deemed to have been given:',
        children: [
          {
            title:
              'in the case of electronic communications, on the first Business Day following the date of transmission;',
          },
          { title: 'in the case of a letter, when delivered, either by hand or courier;' },
          { title: 'In the case of registered mail, 10 days from date of sending.' },
        ],
      },
      {
        title:
          'The Parties are entitled to change the addresses provided for service on 7 days written notice to the other party.',
      },
      {
        title:
          'The Merchant chooses the physical and email addresses provided in the Offer Page as its service address for all purposes arising from or pursuant to this Agreement, including the service of notices and legal proceedings.',
      },
      {
        title:
          'Lula Lend chooses the following addresses for service: <br/>3rd Floor Pier Place <br/>Heerengracht Street <br/>Cape Town <br/>8000 <br/>Email: <a class="lowercase" href="mailto:support@lulalend.co.za">support@lulalend.co.za</a>',
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>legal compliance</p>',
    children: [
      {
        title:
          'Lula Lend has, in the drafting of this Agreement, used its best endeavours to ensure compliance with all applicable Laws. However, to the extent that this Agreement may require further amendment in order to comply with any Law, the Merchant agrees to accept all such amendments and do all such things as may be necessary to give full effect to such amendment which Lula Lend will set out in an addendum to this Agreement.',
      },
      {
        title:
          'The aforesaid amendments will be effective from the date of notice of amendment from Lula Lend to the Merchant.',
      },
      {
        title:
          'Should any provision of this Agreement be found to be inconsistent with any law and/or regulation and is unenforceable, the remaining provisions of this Agreement shall continue in full force and effect.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>certificate of indebtedness</p>',
    subtitle:
      'A certificate signed by one of Lula Lend’s duly authorised officers, whose authority need not be proved, as to theamount owing by the Merchant to Lula Lend at any time, as to the fact that such amount is due and payable, the amount of costs accrued and payable thereon as to any other fact, matter or thing relating to the Merchant’s indebtedness to Lula Lend shall be proof on the face thereof of the facts therein stated and of the amount of the Merchant’s indebtedness for the purpose of provisional sentence or summary judgment or any other proceedings against the Merchant in any competent court, and shall be valid as a liquid document for such purposes. Such certificate shall be deemed sufficient particularly for purposes of pleading or trial in any action or other proceeding instituted by Lula Lend against the Merchant.',
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>cession and assignment</p>',
    children: [
      {
        title:
          'The Merchant shall not assign, cede or otherwise transfer its rights and/or duties under this Agreement in any way.',
      },
      {
        title:
          'Lula Lend may without notice to the Merchant, cede any or all of its rights and/or delegate its obligations under the Agreement either absolutely or as security to any other person or persons (notwithstanding that a cession and/or delegation to more than one person may result in a splitting of claims against the Merchant, which splitting of claims the Merchant hereby agrees to) and on any such cession and/or delegation taking place, the Merchant shall, if so required by any cessionary, make all payments direct to such cessionary.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>kyc – know your customer</p>',
    subtitle:
      'If any law requires Lulalend to comply with “Know Your Customer” or similar identification procedures, the Facilitator will promptly and on written request, supply Lulalend with such information or documentation as requested to carry out and satisfy such “Know Your Customer” or similar identification procedures. The Facilitator does not take responsibility for the accuracy of the information and documentation provided or any verification process in terms thereof.',
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>relationship between the facilitator and lulalend</p>',
    children: [
      {
        title:
          'The Facilitator introduced the Product to the Merchant and assisted the Merchant in completing and submitting the Agreement to Lulalend.',
      },
      {
        title:
          'For the avoidance of doubt, it is recorded that Lulalend performs all administrative functions relating to this Agreement and is responsible for payment of the Advance to the Merchant and the collection thereof other than as provided for herein. The Facilitator is not a Party to this Agreement.',
      },
      {
        title:
          'Upon the Merchant accepting the offer from Lulalend, the Facilitator shall be entitled to an agreed upon commission which will be paid to it by Lulalend.',
      },
    ],
  },
  {
    title:
      '<p class="font-medium text-xl"><span class="slashes">// </span>information provided by facilitator</p>',
    children: [
      {
        title: 'The Merchant hereby acknowledges that the Facilitator has warranted to Lula Lend:',
        children: [
          {
            title:
              'that it has a valid and binding agreement with the Merchant as at Signature Date of this Agreement.',
          },
          {
            title:
              "that all the necessary details required to identify the Merchant, including but not limited to the name, physical and email address of the Merchant, is reflected on the Merchant's online profile of the Facilitator.",
          },
        ],
      },
    ],
  },
  {
    title: '<p class="font-medium text-xl"><span class="slashes">// </span>general</p>',
    children: [
      {
        title:
          'This Agreement constitutes the entire agreement between the Parties and supersedes all and any prior undertakings, agreements and understandings between the Parties. Lula Lend shall be entitled to amend the terms of this Agreement should it, in its sole discretion, deem this to be necessary. Lula Lend shall notify the Merchant of the intended amendments in writing prior to such amendments being enforced. Should the Merchant fail to object to the amendment within 7 days of such notification, the Merchant shall be deemed to have agreed thereto and the amendments will be effective on date of expiry of the 7-day period. Should the Merchant object to the amendments, this Agreement shall automatically terminate and the full outstanding Total Future Revenue Rand Value on date thereof shall be immediately due and payable by the Merchant to Lula Lend.',
      },
      {
        title:
          'No relaxation or indulgence granted by Lula Lend to the Merchant shall be deemed to be a waiver of any of Lula Lend’s rights in terms hereof, nor shall such relaxation or indulgence be deemed to be a notification of any of the terms and conditions of this Agreement or constitute an estoppel.',
      },
      {
        title:
          'All legal costs, including costs as between attorney and his own client, charges and disbursements incurred by Lula Lend in enforcing any of the provisions of this Agreement and costs and disbursements incurred in tracing the Merchant and in collecting or endeavoring to collect all and any amounts payable by the Merchant to Lula Lend, hereunder or otherwise, and all collection commissions and all other taxes, fees and charges of a like nature, shall be for the Merchant’s account and payable on demand.',
      },
      {
        title:
          'This Agreement shall in all respects be governed by and construed in accordance with the laws of the RSA and all disputes, actions and other matters in connection therewith shall be determined in accordance with such law.',
      },
      {
        title:
          'Each clause of this Agreement is severable, the one from the other, and if any clause is found to be defective or unenforceable for any reason by any competent court, then such terms shall be severable and be deemed to be deleted from the other terms or provisions of this agreement which shall continue to be of full force and effect.',
      },
      {
        title:
          'Should any conflict arise between the terms set out in this Agreement and the Offer Page, the terms of this Agreement shall prevail.',
      },
      {
        title:
          'The National Credit Act 34 of 2005 is not applicable to this Agreement as this Agreement is not a credit agreement as contemplated in terms of section 8 of the Act.',
      },
    ],
  },
];
